module.exports = __webpack_public_path__ + "static/media/jadalnia-1-min.56cfe6fe.png";